import { render, staticRenderFns } from "./LoaderView.vue?vue&type=template&id=6e8d8432"
var script = {}
import style0 from "./LoaderView.vue?vue&type=style&index=0&id=6e8d8432&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports